import React from 'react';

const MenuImagePage = ({ menuItems, imageUrl, onMenuChange, onImageUrlChange }) => {
    return (
        <div>
            <ul>
                {menuItems.map((item, index) => (
                    <li key={index}>
                        <input
                            type="text"
                            placeholder={`Elemento ${index + 1}`}
                            value={item}
                            onChange={(e) => onMenuChange(index, e.target.value)}
                        />
                    </li>
                ))}
            </ul>
            <input
                type="text"
                placeholder="URL de la Imagen"
                value={imageUrl}
                onChange={(e) => onImageUrlChange(e.target.value)}
            />
            {imageUrl && <img src={imageUrl} alt="Preview" />}
        </div>
    );
};

export default MenuImagePage;
